import { Reveal } from "@/components/site/Reveal";

export const SectionHeading = ({ eyebrow, title, description, light = false, align = "left" }) => {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <Reveal className={`flex flex-col ${alignCls} max-w-2xl`}>
      {eyebrow && (
        <span className={`eyebrow ${light ? "eyebrow-light" : ""}`}>
          <span className="gold-rule" aria-hidden="true" />
          {eyebrow}
        </span>
      )}
      <h2
        className={`font-display mt-4 text-3xl leading-tight sm:text-4xl lg:text-[2.75rem] ${
          light ? "text-primary-foreground" : "text-primary"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p className={`mt-4 text-base leading-relaxed ${light ? "text-primary-foreground/70" : "text-muted-foreground"}`}>
          {description}
        </p>
      )}
    </Reveal>
  );
};
